import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { CreditCard, Wallet, Landmark, ArrowRight } from "lucide-react";
import { NeuButton, NeuSelect } from "../../components/neu/Neu";
import { BillReceiverPicker } from "./BillReceiverPicker";
import { BillPaySendDialog } from "./BillPaySendDialog";
import { localName } from "../../lib/localName";

// نافذة "دفع الفاتورة" — يختار المحاسب الطريقة + الصندوق + المستلم قبل مرحلة الإرسال.
export const BillPayDialog = ({ bill, boxes = [], employees = [], onDone, onCancel }) => {
  const { t } = useTranslation();
  const [method, setMethod] = useState("cash");
  const [cashboxId, setCashboxId] = useState("");
  const [external, setExternal] = useState(false);
  const [userId, setUserId] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [confirming, setConfirming] = useState(false);
  const boxesFiltered = boxes.filter((b) => method === "cash" ? b.kind === "cash"
                                                              : method === "bank" ? b.kind === "bank" : true);
  const proceed = () => {
    if (method !== "credit" && !cashboxId) { toast.error(t("acct.bills.pay.needBox")); return; }
    if (!name.trim()) { toast.error(t("acct.bills.pay.needReceiver")); return; }
    setConfirming(true);
  };
  const chosenBox = boxes.find((b) => b.id === cashboxId);

  return (
    <>
    <div className="fixed inset-0 z-50 grid place-content-center bg-black/60 p-4" onClick={onCancel}>
      <div onClick={(e) => e.stopPropagation()} data-testid="bill-pay-dialog"
           className="w-[min(640px,95vw)] max-h-[92vh] overflow-y-auto rounded-3xl bg-background shadow-2xl">
        <div className="rounded-t-3xl bg-gradient-to-l from-blue-700 to-blue-900 p-6 text-white">
          <div className="flex items-center gap-3">
            <CreditCard className="h-6 w-6" />
            <div className="flex-1">
              <h3 className="text-lg font-black">{t("acct.bills.pay.title")}</h3>
              <p className="mt-1 text-xs opacity-90">{bill.supplier_invoice_no || bill.description || "—"}</p>
            </div>
          </div>
          <p className="mt-4 text-center text-3xl font-black" dir="ltr">{bill.currency || ""} {bill.total}</p>
        </div>
        <div className="grid gap-4 p-6">
          <div>
            <p className="label-xs mb-2">{t("acct.bills.pay.method")} *</p>
            <NeuSelect data-testid="pay-method" value={method} onChange={(e) => setMethod(e.target.value)}>
              <option value="cash">💰 {t("acct.methods.cash")}</option>
              <option value="bank">🏦 {t("acct.methods.bank")}</option>
              <option value="credit">📄 {t("acct.methods.credit")}</option>
            </NeuSelect>
          </div>
          {method !== "credit" ? (
            <div>
              <p className="label-xs mb-2 flex items-center gap-2 text-primary">
                {method === "bank" ? <Landmark className="h-4 w-4" /> : <Wallet className="h-4 w-4" />}
                {t("acct.bills.pay.box")} *
              </p>
              <NeuSelect data-testid="pay-box" value={cashboxId} onChange={(e) => setCashboxId(e.target.value)}>
                <option value="">-- {t("acct.bills.pay.pickBox")} --</option>
                {boxesFiltered.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.kind === "bank" ? "🏦 " : "💰 "}{localName(b)} — {b.balance} {b.currency}
                  </option>
                ))}
              </NeuSelect>
            </div>
          ) : null}
          <BillReceiverPicker employees={employees} branchId={bill.branch_id}
                              external={external} setExternal={setExternal}
                              userId={userId} setUserId={setUserId}
                              name={name} setName={setName} phone={phone} setPhone={setPhone} />
          <div className="rounded-2xl border-2 border-amber-500/40 bg-amber-500/5 p-3 text-xs font-bold text-amber-800">
            💡 {t("acct.bills.pay.disclaimer")}
          </div>
        </div>
        <div className="flex flex-wrap justify-end gap-3 border-t border-border/40 p-4">
          <NeuButton data-testid="pay-cancel" onClick={onCancel}>{t("app.cancel")}</NeuButton>
          <NeuButton variant="primary" data-testid="pay-continue" onClick={proceed}>
            {t("acct.bills.pay.continue")} <ArrowRight className="h-4 w-4" />
          </NeuButton>
        </div>
      </div>
    </div>
    {confirming ? (
      <BillPaySendDialog bill={bill} method={method} cashboxId={cashboxId} chosenBox={chosenBox}
                          external={external} receiverName={name.trim()} receiverPhone={phone.trim()}
                          receiverUserId={external ? null : (userId || null)}
                          onCancel={() => setConfirming(false)}
                          onDone={() => { setConfirming(false); onDone(); }} />
    ) : null}
    </>
  );
};
